/**
 * Synthetic tropical-storm overlay for the CNIC Hawaii demo.
 * There is no live NHC Central Pacific feed behind this — the ring covers
 * Navy Region Hawaii installations on Oahu and Kauai, and the track reads
 * as a system approaching Pearl Harbor from the southeast.
 */

export const CNIC_HAWAII_STORM_LAYER_NAME =
  'Tropical storm warning — approaching Navy Region Hawaii';

export const CNIC_HAWAII_STORM_LAYER_DESCRIPTION =
  'Synthetic NHC Central Pacific tropical storm warning covering CNIC installations on Oahu and Kauai. Approach track from the southeast toward Pearl Harbor.';

export const CNIC_HAWAII_STORM_WARNING_NAME = 'Tropical storm warning area';

export const CNIC_HAWAII_STORM_WARNING_DESCRIPTION =
  'Tropical-storm-force winds, heavy rain and harbor surge across Navy Region Hawaii.';

export const CNIC_HAWAII_STORM_TRACK_NAME =
  'Storm track — approaching Pearl Harbor';

export const CNIC_HAWAII_STORM_TRACK_DESCRIPTION =
  'Forecast motion from southeast of the islands toward Joint Base Pearl Harbor-Hickam.';

export const CNIC_HAWAII_STORM_POLYGON_COLOR = '#f97316';
export const CNIC_HAWAII_STORM_POLYGON_OPACITY = 0.32;

/** Joint Base Pearl Harbor-Hickam — the track should finish here. */
export const CNIC_HAWAII_STORM_TRACK_END: [number, number] = [
  -157.9439, 21.3498,
];

/**
 * Closed warning ring covering Oahu and Kauai CNIC installations.
 * Coordinates are [lon, lat] and include all CNIC_HAWAII_FACILITIES.
 */
export const CNIC_HAWAII_STORM_WARNING_RING: number[][] = [
  [-160.2, 21.5],
  [-160.0, 22.4],
  [-157.4, 22.3],
  [-157.2, 21.0],
  [-158.5, 20.8],
  [-160.2, 21.5],
];

/** SE → NW approach into Pearl Harbor. */
export const CNIC_HAWAII_STORM_TRACK: number[][] = [
  [-156.5, 20.2],
  [-156.85, 20.45],
  [-157.2, 20.75],
  [-157.5, 21.0],
  [-157.75, 21.2],
  CNIC_HAWAII_STORM_TRACK_END,
];
